<template>
  <div class="grid-item h-100 mb-3">
    <!-- <div class="status-overlay">{{ value.status }}</div> -->
    <b-card class="h-100 store-photo-thumbnail">
      <template #header>
        <div class="ratio ratio-4x3">
          <b-card-img 
            class="card-store-photo img-fluid"
            :src="signedUrl" 
            alt="Card image" 
            style="object-fit: cover;"
          ></b-card-img>
        </div>
      </template>
      <div
        class="d-flex justify-content-between align-items-center flex-wrap mb-3"
      >
        <div
          :title="value.storeName"
          class="store-name text-primary text-capitalize"
        >
          {{ shortenedTitle }}
        </div>
        <!-- <div class="bx bxs-error-circle"></div> -->
      </div>
      <div class="store-address mb-3" v-if="false">
        {{ value.fullAddress }}<br />
        <div v-if="loggedIn">
          <i class="bx bx-map me-1"></i> {{ value.landmark }}
        </div>
      </div>

      <div class="d-flex d-flex-row business-details mb-3">
        <div class="me-2 col d-flex d-flex-row">
          <div>
            <img
              src="@/assets/images/store-icon.png"
              class="me-1 align-items-center"
            />
          </div>
          <div class="text-truncate">
            {{ value.businessType ? this.shortenedBusinessType : "--" }}
          </div>
        </div>
        <!-- <div class="col d-flex d-flex-row">
          <div>
            <img
              src="@/assets/images/calendar-icon.png"
              class="me-1 align-items-center"
            />
          </div>
          <div>
            {{ value.duration ? `${value.duration} months` : "--" }}
          </div>
        </div> -->
      </div>

      <div class="d-flex d-flex-row business-details mb-3">
        <!-- <div class="col me-2 d-flex d-flex-row">
          <div>
            <img
              src="@/assets/images/mobile-icon.png"
              class="me-1"
              style="margin-left: -2px"
            />
          </div>
          <div>
            {{ value.mobileNumber ? value.mobileNumber : "--" }}
          </div>
        </div> -->
        <div class="col d-flex d-flex-row">
          <div>
            <img src="@/assets/images/location-pin-black.png" class="me-1" />
          </div>
          <div>
            {{ value.city || value.province ? shortenedLocation : "--" }}
          </div>
        </div>
      </div>

      <div class="d-flex sub-listings flex-wrap">
        <div
          class="sub-listing-item me-1 mb-1"
          v-for="(item, index) in value.listings"
          :key="index"
          :class="{ 'blur-item': index > 0 && !loggedIn }"
        >
          <span class="capitalize">{{ item.placement }}</span>
          <!-- <span class="capitalize">{{ item.type }}</span> |
          <span>{{ item.dimension }}</span> | <span>{{ item.placement }}</span> -->
        </div>
      </div>

      <template #footer>
        <div class="d-flex flex-row align-items-center mb-2">
          <div class="rental-price col-8 mt-auto">
            PHP {{ priceRange | toCurrency }}/<small>month</small>
          </div>
          <div class="text-end col-4 mt-auto">
            <b-button
              @click="viewFullDetails"
              variant="primary"
              size="sm"
              class="ps-2 pe-2 fd-border-radius"
              >Full Details</b-button
            >
          </div>
        </div>
      </template>
    </b-card>
  </div>
</template>

<script>
import { authComputed, showFeatureUnavailable } from "@/state/helpers";
//   import FavoriteItem from '../../../components/widgets/favorite-item.vue';

export default {
  props: ["value"],
  data() {
    return {};
  },
  components: {
    //   FavoriteItem
  },
  computed: {
    ...authComputed,
    shortenedTitle() {
      var length = 25;

      if (this.value.storeName == null) {
        return "";
      }

      if (this.value.storeName.length <= length) {
        return this.value.storeName;
      }

      var text = this.value.storeName.substring(0, length);
      // var last = text.lastIndexOf(" ");
      // text = text.substring(0, last);
      return text + "...";
    },
    shortenedBusinessType() {
      var length = 25;

      if (this.value.businessType == null) {
        return "";
      } 
      
      if (this.value.businessType.length <= length) {
        return this.value.businessType;
      }

      var text = this.value.businessType.substring(0, length);
      return text + "...";
    },
    shortenedLocation() {
      var length = 20;

      let location = `${this.value.city}, ${this.value.province}`

      if (location == null) {
        return "";
      } 
      
      if (location <= length) {
        return this.value.businessType;
      }

      var text = location.substring(0, length);
      return text + "...";
    },
    priceRange() {
      let minPrice = Math.min(...this.value.price),
        maxPrice = Math.max(...this.value.price);
      if (minPrice == maxPrice) {
        return minPrice;
      } else {
        return `${minPrice}-${maxPrice}`;
      }
    },
  },
  asyncComputed: {
    async signedUrl() {
      return this.value.storePhoto;
      // return await Storage.get(this.value.storePhoto, { level: 'public' });
    },
  },
  methods: {
    ...showFeatureUnavailable,
    triggerDisabled() {
      this.$toast.showToast(
        "info",
        "Coming Soon!",
        "Stay tuned for this feature."
      );
    },
    viewFullDetails() {
      this.$router.push(
        this.$route.query.redirectFrom || {
          name: "store-campaign-details", params: {
            id: this.value.businessId, 
            chid: this.value.campaignHdrId,
            pid: this.value.campaignDtlId
          }
        }
      )
    }
  },
  async mounted() {
    console.log(JSON.stringify(this.value));
  },
};
</script>

<style scoped>
.rental-price {
  font-size: 16px;
  font-weight: 700;
}

.store-name {
  font-size: 18px;
  font-weight: 700;
}

.store-address {
  font-size: 10px;
  font-weight: 400;
}

.business-details {
  font-size: 10px;
  font-weight: 400;
}

.sub-listing-item {
  font-weight: 600;
  font-size: 7px;
  background: rgba(0, 98, 255, 0.1);
  padding: 2px 10px 2px 10px;
  border-radius: 8px;
}

.capitalize {
  text-transform: capitalize;
}

.grid-item {
  position: relative;
}

.select-item {
  position: absolute;
  top: 10px;
  left: 30px;
  z-index: 1;
}

.blur-item {
  filter: blur(2px);
}

.fav-item {
  right: 10px;
  top: 10px;
  position: absolute;
  z-index: 10;
}

.store-photo-thumbnail > img {
  /* height: 180px; */
  width: auto;
  height: auto;
  object-fit: cover;
}

.store-photo-thumbnail .card-header {
  padding: 0;
}

.card-store-photo {
  border-radius: 0;
}

.bxs-error-circle {
  font-size: 30px;
  color: #bc3d40 !important;
}

.status-overlay {
  right: 10px;
  top: 174px;
  position: absolute;
  z-index: 10;
  color: white;
  background-color: #a50e63;
  padding: 0px 1rem 0px 1rem;
  border-radius: 11px;
  font-size: 12px;
}

.fd-border-radius {
  border-radius: 8px;
}

.card-body {
  padding-bottom: 0px;
}
.card-footer {
  border-top: 0px;
  padding-top: 0px;
}

.truncated {
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
</style>
